import React from "react";
import { Link, Navigate } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { auth,login } from "../../../reducers/authSlice";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Alert from "../../../components/alert/alert.component";

class Login extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      verified: false,
      email: "",
      password: "",
      signInBtn: true,
      redirect: false
    };
  }

  async componentDidMount() {
    this._isMounted = true;

    // Immediately check if already authenticated (e.g. after refresh)
    await this.props.auth();

    setTimeout(() => {
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    }, 1000);

    // Check for verified param
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let verified = params.get("verified");
    if (verified === "true") {
      this.setState({ verified: true });
      toast("Account has been verified, please login", {
        containerId: "B",
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _submitHandler = async (e) => {
  e.preventDefault();
  const { email, password } = this.state;

  this.setState({ loading: true, signInBtn: false });

  try {
    // Perform login
    const res = await this.props.login({
      email,
      password,
      type: "admin",
    });
    console.log("res",res,"token",res?.payload?.token)

    // Check if login was successful
  if (res?.payload?.token) {
    // debugger;
  localStorage.setItem("token", res?.payload?.token);
  const res1 = await this.props.auth();
  console.log("res1",res1)
  this.setState({  loading: false,redirect: true });
} else {
  toast.error("Login failed", { containerId: "B" });
  this.setState({ loading: false, signInBtn: true });
}

  } catch (err) {
    this.setState({ loading: false, signInBtn: true });
    toast.error("Login failed due to server error", { containerId: "B" });
  }
};


  render() {

//     console.log(toast); // Should log the `toast` object
// console.log("ppp",toast.POSITION); // Should log the `POSITION` object
// console.log("ttt",toast.POSITION.TOP_RIGHT); // Should log "top-right"
const { isAuth, loading: authLoading } = this.props._auth;
const { loading, email, password, signInBtn, redirect } = this.state;
console.log("redirect",redirect,isAuth,authLoading,loading)

    TopBarProgress.config({
      barThickness: 4,
      barColors: {
        0: "rgb(51, 201, 45, .7)",
        ".3": "rgb(255, 77, 107, .7)",
        "1.0": "rgb(200, 125, 255, .7)",
      },
      shadowBlur: 5,
      shadowColor: "rgba(0, 0, 0, .5)",
    });

    
    if (isAuth && !authLoading) {
  return <Navigate to="/admin/dashboard" replace />;
}
    if (redirect) {
  return <Navigate to="/admin/dashboard" replace />;
}

    // Redirect if login is successful
   return (
      <div className="container-scroller">
        {loading && <TopBarProgress />}

        <ToastContainer
        stacked 
          enableMultiContainer
          containerId="B"
          // // position={toast.POSITION.TOP_RIGHT}
          position="top-right" // Hardcoded position
        />

        <div className="container-fluid page-body-wrapper full-page-wrapper">
          <div className="content-wrapper d-flex align-items-center auth">
            <div className="row flex-grow">
              <div className="col-lg-4 mx-auto">
                <div className="auth-form-light text-left p-5">
                  <div className="brand-logo">
                    <img
                      src="/assets/images/logo.svg"
                      alt="logo"
                      draggable={false}
                    />
                  </div>
                  <h4>Hello! let's get started</h4>
                  <h6 className="font-weight-light">
                    Enter your email address to sign in or to create an account.
                  </h6>

                  <Alert />

                  <form
                    onSubmit={(e) => {
                      this._submitHandler(e);
                    }}
                    className="pt-3"
                  >
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control form-control-lg"
                        id="email"
                        name="password"
                        placeholder="Email"
                        value={email}
                        onChange={(e) =>
                          this.setState({ email: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        className="form-control form-control-lg"
                        id="password"
                        name="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) =>
                          this.setState({ password: e.target.value })
                        }
                      />
                    </div>
                    <div className="mt-3">
                      {signInBtn ? (
                        <button
                          className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                          type="submit"
                        >
                          SIGN IN
                        </button>
                      ) : (
                        <button
                          className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                          type="submit"
                          disabled
                        >
                          SIGN IN
                        </button>
                      )}
                    </div>
                    <br />
                    <div className="my-2 d-flex justify-content-between align-items-center">
                      <Link
                        to={"/admin/forgot"}
                        className="auth-link text-black"
                      >
                        Forgot password?
                      </Link>
                    </div>

                    <div className="text-center mt-4 font-weight-light">
                      {" "}
                      Don't have an account?{" "}
                      <Link to={"/admin/register"} className="text-primary">
                        Register
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

login.propsTypes = {
  login: PropTypes.func.isRequired,
};

auth.propsTypes = {
  auth: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});

const mapDispatchToProps = (dispatch) => {
  return {
    auth: () => dispatch(auth()),
    login: (data) => dispatch(login(data)),
  };
};
Login.propTypes = {
  login: PropTypes.func.isRequired,
  auth: PropTypes.func.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(Login);
